export default {
  countryCode: 'AU',
  regionLinks: [
    {
      title: 'Sydney',
    },
    {
      title: 'Central Coast & Hunter Valley',
      slug: '/central-coast/',
    },
    {
      title: 'Gold Coast',
    },
    {
      title: 'Melbourne',
    },
    {
      title: 'Byron Bay & surrounds',
      slug: '/byron-bay/',
    },
    {
      title: 'Brisbane',
    },
    {
      title: 'Adelaide',
    },
    {
      title: 'Canberra',
    },
    {
      title: 'Perth',
    },
    {
      title: 'Mandurah, Bunbury & South West',
      slug: '/south-west/',
    },
    {
      title: 'Sunshine Coast',
    },
    {
      title: 'Darwin',
    },
    {
      title: 'Newcastle',
    },
    {
      title: 'Wollongong',
    },
    {
      title: 'Hobart',
    },
    {
      title: 'Geelong & The Bellarine',
      slug: '/geelong/',
    },
    {
      title: 'Townsville',
    },
    {
      title: 'Cairns',
    },
    {
      title: 'Toowoomba',
    },
    {
      title: 'Launceston',
    },
    {
      title: 'Mackay',
    },
    {
      title: 'Bendigo',
    },
    {
      title: 'Ballarat',
    },
    {
      title: 'Port Douglas',
    },
    {
      title: 'Airlie Beach,',
    },
  ],
};
